/* eslint-disable import/prefer-default-export */

// Block type 0, 1 are allowed to be set as media or web content.
export const editableBlockType: number[] = [0, 1, 2];
